<template>
	<div class="panel white-square-1">
		<div class="widgets-header">
			<relogio :locked="locked" :restante="simulado.TempoRestante"></relogio>
			<acessos :total="simulado.TotalAcessos" :maximo="simulado.SimuladoMaximoDeAcessos"></acessos>
		</div>
		<div class="background"></div>
		<div class="body">
			<breadcrumb 
			:parts="simulado.Parts" 
			:selected="selectedPart"
			@changed="changeSelected"
			></breadcrumb>
			<div class="part-wrapper">
				<component :locked="locked" :key="part.PartId" :is="tipoPart" :part="part"></component>
			</div>
		</div>
	</div>
</template>

<script>
	import breadcrumb from './Breadcrumb.vue'
	import axios from '@/http/axios.js'
	import bus from '@/bus/event-bus.js'

	import audio from './audio/PerguntaAudio.vue'
	import palavras from './lacuna-palavra/PerguntaPalavra.vue'
	import multiplaescolha from './multipla-escolha/PerguntaMultiplaEscolha'
	import perguntaParagrafo from './lacuna-paragrafo/PerguntaLacunaParagrafo'
	import perguntaRelacione from './relacione/PerguntaRelacione'
	import perguntaRelacioneAudio from './relacione-audio/PerguntaAudioRelacione'
	import relogio from '../Relogio'
	import acessos from '../Acessos'

	export default {
		props: ['simulado', 'locked'],

		data() {
			return {
				isAudioPlaying: false,
				selectedPart: 1,
				prevPart: 0
			}
		},

		computed: {
			part() {
				return this.getByOrdem(this.selectedPart);
			},
			tipoPart() {
				if(this.part.PartTipoId == 4) {
					return 'pergunta-audio'
				}
				if(this.part.PartTipoId == 2) {
					return 'pergunta-palavra'
				}
				if(this.part.PartTipoId == 1) {
					return 'pergunta-multipla'
				}
				if(this.part.PartTipoId == 3) {
					return 'lacuna-paragrafo'
				}
				if(this.part.PartTipoId == 5) {
					return 'relacione-audio'
				}
				if(this.part.PartTipoId == 6) {
					return 'relacione'
				}
				return ''
			}
		},

		mounted() {
			bus.$on('next.part', () => {
				this.triggerNext()
			})

			bus.$on('previous.part', () => {
				this.triggerPrevious()
			})

			bus.$on('audio.started', () => {
				this.isAudioPlaying = true
			})

			bus.$on('audio.played', () => {
				this.isAudioPlaying = false
			})
		},

		watch: {
			selectedPart(ordem, old) {
				this.isAudioPlaying = false
				this.prevPart = old
				this.pingPart()
			}
		},

		methods: {
			getByOrdem(ordem) {
				return this.simulado.Parts.find((e, i, a) => {
					return e.Ordem === ordem;
				})
			},

			pingPart() {
				bus.$emit('part.changed', 
					this.getByOrdem(this.prevPart), 
					this.getByOrdem(this.selectedPart))
			},

			changeSelected(ordem) {
				if(!this.isAudioPlaying) {
					this.selectedPart = ordem
				} else {
					this.showAudioPlayingMessage((modal) => {
						this.selectedPart = ordem
						modal.hide()
					})
				}
			},

			showAudioPlayingMessage(callback) {
				bus.$emit('show.message', 'Mudando de questão você não poderá mais ouvir este áudio. Prosseguir?', callback)
			},

			triggerPrevious() {
				if(!this.isAudioPlaying) {
					this.previousPart()
				} else {
					this.showAudioPlayingMessage((modal) => {
						this.previousPart()
						modal.hide()
					})
				}
			},

			previousPart() {
				if(this.selectedPart > 1) {
					this.selectedPart = this.selectedPart - 1;
				}
			},

			triggerNext() {
				if(!this.isAudioPlaying) {
					this.nextPart()
				} else {
					this.showAudioPlayingMessage((modal) => {
						this.nextPart()
						modal.hide()
					})
				}
			},

			nextPart() {
				if(this.selectedPart < this.simulado.Parts.length) {
					this.selectedPart = this.selectedPart + 1;
				}
			}
		},

		components: {
			'breadcrumb': breadcrumb,
			'pergunta-audio': audio,
			'pergunta-palavra': palavras,
			'pergunta-multipla': multiplaescolha,
			'relogio': relogio,
			'acessos': acessos,
			'lacuna-paragrafo': perguntaParagrafo,
			'relacione': perguntaRelacione,
			'relacione-audio': perguntaRelacioneAudio
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/perguntas/Perguntas.vue